<template>
  <div class="hkok-title">
    <div class="en-text">
      <span>{{ en }}</span>
    </div>
    <h1 class="zh-text">{{ zh }}</h1>
  </div>
</template>

<script>
export default {
  props: {
    zh: {
      type: String,
      required: true
    },
    en: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.hkok-title {
}
.en-text {
  color: #ababab;

  & > span {
    padding-right: 10px;
    border-right: 2px solid #3a8df5;
  }
}

.zh-text {
  margin-top: 2px;
  position: relative;
  &::after {
    color: #3a8df5;
    position: absolute;
    content: "。";
  }
}
</style>
